import useSWR from "swr";
import { authApi } from "@/lib/api";
import { useAuth } from "@/features/auth/context/auth-context";

export type SubscriptionInfo = {
  id: string;
  subscriptionId: string;
  name: string;
  planName: string;
  description?: string;
  planId?: string;
  status: string;
  active: boolean;
  isSystem?: boolean;
};

export function useUserSubscriptions() {
  const { token } = useAuth();

  const { data, error, isLoading, mutate } = useSWR<SubscriptionInfo[]>(
    token ? "/auth/subscriptions" : null,
    () => authApi.subscriptions(),
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      dedupingInterval: 60000,
    }
  );

  return {
    subscriptions: data || [],
    isLoading,
    isError: error,
    mutate,
  };
}
